import { Flex } from "antd";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AreaFilterForm from "../../../components/AgencyComp/AreaCode/AreaFilterForm";
import CodesTable from "../../../components/AgencyComp/AreaCode/CodesTable";
import { fetchAreaCodes, fetchBankAreaCodes } from "../../../store/agencySlice";
import { fetchBankDashboard } from "../../../store/portfolioSlice";
import "./AgencyAreaCodes.scss";

const AgencyAreaCodes = () => {
  const { area_codes_list, area_codes_loading, bank_area_codes, bank_area_codes_loading } = useSelector(
    (state) => state?.agency
  );
  const dispatch = useDispatch();

  const { bankDashboard, bankDashboard_loading } = useSelector(
    (state) => state?.portfolio
  );

  useEffect(() => {
    dispatch(fetchBankAreaCodes());
    dispatch(fetchBankDashboard());
    dispatch(fetchAreaCodes())
  }, [dispatch]);

  return (
    <Flex className="agencyAreaCodes" style={{ width: "100%", height: "100%" }}>
      <AreaFilterForm bankData={bankDashboard} areaData={area_codes_list} />
      <CodesTable data={bank_area_codes} loading={bank_area_codes_loading} />
    </Flex>
  );
};

export default AgencyAreaCodes;
